// extracted by mini-css-extract-plugin
export default {"blogsWrapper":"Blog_blogsWrapper__7u8eP","blog":"Blog_blog__G4QhO","headline":"Blog_headline__8Xihg","content":"Blog_content__nnmOA"};